/**
 * @fileoverview パスワードリセット成功画面
 *
 * このファイルでは、パスワードリセットプロセスが正常に完了した後に
 * ユーザーに表示される成功メッセージ画面を定義しています。
 */

/**
 * パスワードリセット成功画面コンポーネント
 *
 * パスワードのリセットが正常に完了したことをユーザーに通知し、
 * ログイン画面へのリンクなど次のステップへのナビゲーションを提供します。
 *
 * @returns {JSX.Element} パスワードリセット成功メッセージ画面
 */
import { Stack, Text } from "@mantine/core";

import { useNavigate } from "@/router";
import { Card } from "@/components/card";
import { Button } from "@/components/button";

export default function ResetPasswordSuccessPage() {
  const navigate = useNavigate();

  return (
    <Card title="パスワードリセット">
      <Stack className="gap-10">
        <Text>新たなパスワードを登録しました。</Text>
        <div className="flex justify-end">
          <Button text="トップページへ戻る" onClick={() => navigate("/")} />
        </div>
      </Stack>
    </Card>
  );
}
